/**
 * https://storybook.js.org/docs/react/writing-stories/decorators
 */
import { withMarker } from './withMarker';

const preview = {
  decorators: [withMarker],
};

export default preview;
